import { getTrackingHomeOrderType } from '../../selectors/trackingSelectors';

import {
  TRACK_ENTERED_LOCATION,
  TRACK_ADDRESS_NOT_DELIVERABLE,
  TRACK_ADDRESS_REFINE,
  TRACK_SEARCH_LOCATION_CHANGE,
  TRACK_TAPPED_LOCATION_PICKER,
  TRACK_GEOLOCATION_AVAILABLE,
  TRACK_GEOLOCATION_ATTEMPT,
} from './types';

export function trackEnteredLocation() {
  return (dispatch) => {
    dispatch({
      type: TRACK_ENTERED_LOCATION,
      payload: {
        name: 'Entered Location',
        properties: {},
      },
    });
  };
}

export function trackAddressNotDeliverable({
  action,
  sourceView,
  searchString,
  postCode,
  lat,
  lng,
}) {
  return (dispatch) => {
    dispatch({
      type: TRACK_ADDRESS_NOT_DELIVERABLE,
      payload: {
        name: 'Address Not Deliverable',
        properties: {
          action,
          'Source view': sourceView,
          'Post Code': postCode,
          'Search String': searchString,
          geo_lat: lat,
          geo_long: lng,
        },
      },
    });
  };
}

export function trackAddressRefine({
  action,
  sourceView,
  postCode,
  label,
  searchString,
  lat,
  lng,
  addressId,
}) {
  return (dispatch) => {
    dispatch({
      type: TRACK_ADDRESS_REFINE,
      properties: {
        name: 'Address Refine',
        action,
        'Source view': sourceView,
        label,
        'Post Code': postCode,
        'Search String': searchString,
        geo_lat: lat,
        geo_long: lng,
        'Address ID': addressId,
      },
    });
  };
}

export function trackGeolocationAvailable({ action, sourceView, isLoggedIn }) {
  return (dispatch) => {
    dispatch({
      type: TRACK_GEOLOCATION_AVAILABLE,
      payload: {
        name: 'Browser Geolocation available',
        properties: {
          action,
          'Source view': sourceView,
          isLoggedIn,
        },
      },
    });
  };
}

export function trackGeolocationAttempt({
  action,
  sourceView,
  tld,
  isLoggedIn,
  hasSavedAddresses,
}) {
  return (dispatch) => {
    dispatch({
      type: TRACK_GEOLOCATION_ATTEMPT,
      payload: {
        name: 'Browser Geolocation attempted',
        properties: {
          action,
          'Source view': sourceView,
          tld,
          isLoggedIn,
          hasSavedAddresses,
        },
      },
    });
  };
}

export function trackSearchLocationChange({ action, sourceView, postCode, lat, lng }) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: TRACK_SEARCH_LOCATION_CHANGE,
      payload: {
        name: 'Changed search location',
        properties: {
          ...getTrackingHomeOrderType(state),
          action,
          'Source view': sourceView,
          'Post Code': postCode,
          geo_lat: lat,
          geo_long: lng,
        },
      },
    });
  };
}

export function trackTappedLocationPicker(sourceView) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: TRACK_TAPPED_LOCATION_PICKER,
      payload: {
        name: 'Tapped Location Picker',
        properties: {
          ...getTrackingHomeOrderType(state),
          'Source view': sourceView,
        },
      },
    });
  };
}
